import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext';
import { FrenmoProvider } from './contexts/FrenmoContext';
import { MyFriendsProvider } from './contexts/MyFriendsContext';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <BrowserRouter>
    <FrenmoProvider>
      <UserProvider>
        <MyFriendsProvider>
          <App />
        </MyFriendsProvider>
      </UserProvider>
    </FrenmoProvider>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
